import React, { useEffect, useState } from "react";
import { getYouTubeVideoId } from "../../../utils/utils";
import Icon from "../icons/Icon";
import iconsList from "../icons/iconsList";
import classes from "./PopupModal.module.scss";

const PopupModal = ({ url, onClose }) => {

    const [isYouTube, setIsYouTube] = useState(false);
    const [isPdf, setIsPdf] = useState(false);
    const [embedUrl, setEmbedUrl] = useState("");

    useEffect(() => {
        const cleanUrl = url || "";
        const yt = cleanUrl.includes("youtube.com") || cleanUrl.includes("youtu.be");
        const pdf = cleanUrl.split("?")[0].toLowerCase().endsWith(".pdf");
        setIsYouTube(yt);
        setIsPdf(pdf);
        let nextEmbed = "";

        if (yt) {
            if (cleanUrl.includes("youtube.com/embed/"))
                nextEmbed = cleanUrl;
            else {
                const id = getYouTubeVideoId(cleanUrl);
                nextEmbed = id ? `https://www.youtube.com/embed/${id}?autoplay=1&mute=1` : "";
            }
        }
        else if (pdf)
            nextEmbed = `${cleanUrl}#toolbar=0&navpanes=0&scrollbar=0`;

        setEmbedUrl(nextEmbed);
    }, [url]);

    const onOverlayClick = () => onClose?.();

    return (
        <div className={classes.overlay} onClick={onOverlayClick} role="dialog" aria-modal="true">
            <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
                <div className={classes.sideIcons}>
                    <button type="button" className={classes.iconBtn} onClick={onClose}>
                        <Icon name={iconsList.close} size={24} />
                    </button>
                   
                </div>
                <div className={classes.content}>
                    {isYouTube &&
                        <iframe
                            key={embedUrl}
                            className={classes.iframe}
                            src={embedUrl}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="YouTube video"
                        />
                    }
                    {isPdf && <iframe key={embedUrl} className={classes.iframe} src={embedUrl} title="PDF Viewer" />}
                </div>
            </div>
        </div>
    );
};

export default PopupModal;
